import React from "react";
import { Sidebar, Icon } from "semantic-ui-react";

export const SidebarOverlay = ({ visible, children, onClose }) => {
  return (
    <div className="audit-details">
      <Sidebar animation='overlay' className="audit-sidebar" direction='right' vertical="true" visible={visible}>
        <div className="audit-details-header">
          <h3>Event Details</h3>
          <Icon name='times circle' size='large' onClick={onClose} />
        </div>
        <pre className="audit-pre">{JSON.stringify(children, null, 2)}</pre>
      </Sidebar>
      <div className="mask" onClick={onClose}></div>
    </div>
  );
};
